import { InternalPageDataDto } from '../types';

export const mapInternalPageData = (data: InternalPageDataDto) => ({
  pageSubtitle: Boolean(data.page_subtitle)
    ? data.page_subtitle
    : data.page_title,
  pageText: data.page_text,
});
